import React, { Component, Fragment } from "react";
import axios from "axios";
import LayoutOperation from "../../components/layout_operation";
import {
  Collapse,
  Form,
  Input,
  Modal,
  Table,
  Spin,
  Drawer,
  Select,
  Radio,
  Checkbox,
  DatePicker,
  Image,
  Tooltip,
  Upload,
  message,
} from "antd";

import { CopyOutlined, PlusOutlined } from "@ant-design/icons";
import ModalSuccess from "../../components/Modal_Success";
import ModalGiveStarScore from "../../components/Modal_GiveStarScore/Modal_GiveStarScore";
import moment from "moment";
import Map from "../../ui/map_full_detail";
import ServiceApi from "../../services/ServiceApi";
import DynamicEditable from "../../services/ui/dynamic_edit_table";
import Cookies from "js-cookie";
import { connect } from "react-redux";
import { changeLang } from "../../actions/langAction";
import { setDynamic } from "../../actions/dynamicAction";
import Api from "../../services/ServiceApi";
/* datadynamic */
import Renderdynamic from "../../components/DynamicForm_Render/render_detail";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import JSZip, { filter } from "jszip";
import { saveAs } from "file-saver";
import heic2any from "heic2any";
var zip = new JSZip();

const { Panel } = Collapse;
const { Option } = Select;

class FullDetailJob extends Component {
  constructor(props) {
    super(props);
    this.handleDataTable = this.handleDataTable.bind(this);
    this.state = {
      data: {
        name: "",
      },
      visible: {
        approve: false,
        reject: false,
        approve_success: false,
        reject_success: false,
      },
      asset: [],
      modalstatus: false,
      step: [
        { text: "Ack Job" },
        // { text: "On the way" },
        { text: "On Process" },
        { text: "Finished" },
        { text: "TL Approve" },
      ],
      active_step: 0,
      data_mainttenance: [],
      data_assignment: [],
      data_material: {
        modal_material: "",
        power_supply: "",
        receiving_card: "",
        sending: "",
        hub: "",
        tv: "",
        other: "",
      },
      Team_name: [],
      loading: true,
      jobstatus_name: [
        "Wait Assign",
        "Wait Assign",
        "Wait ack job",
        "On process",
        "Finish",
        "Wait Approve",
        "Complete",
        "Wait Reassign",
        "Stop time",
        "Cancel",
        "Closed (Not Finish)",
        "Stop Time",
        "On the way",
        "Request progress",
        "Waiting hardware",
        "Created Job",
      ],
      check_job_status: 0,
      Inform_Person: "",
      InformDate: "",
      dataTab: [],
      dataCol: [],
      mDataMasFormJson: {},
      myHtml: "",
      dataJSON: [],
      lang: "",
      tableClass: [],
      factupdate: false,
      data_translate: [],
      lang_locale: "",
      visibleDrawer: false,
      current_page: "",
      jsonOutput: {},
      dataConfDynamic: {},
      language_name: "",
      dynamic_state: {},
      clonedynamic_state: {},
      dynamic_cancel: {},
      set_pic: [],
      check_stop_time: "",
      display_stop_time: "",
      display_stop_time_detail: "",
      check_approve: false,
      Workflow: {},
      visible_modal_approve: false,
      visible_modal_reject: false,
      visible_modal_reject_status: false,
      maseter_reject: [],
      dataapprove: {},
      form: {},
      label_informDetail: [
        { value: "emp_inform_date", text: "Inform Date" },
        { value: "ma_period", text: "MA Period" },
        { value: "inform_name", text: "Inform by" },
        { value: "inform_detail", text: "Inform Detail" },
        { value: "inform_remark", text: "Remark" },
      ],
      label_informDetail_right: [
        { value: "sla_name", text: "SLA Level" },
        { value: "sla_time_day", text: "Standard Day" },
        { value: "sla_time_hour", text: "Standard Hour" },
        { value: "sla_time_min", text: "Standard Minute" },
        { value: "priority_level", text: "Priority" },
        { value: "job_status_name", text: "Status" },
        { value: "attached_photo", text: "Attached" },
      ],
      label_damage_check: [
        { value: "service_type_level_1", text: "Object Part" },
        { value: "service_type_level_2", text: "Service Type" },
        { value: "service_type_level_3", text: "Category Type" },
        { value: "service_type_level_4", text: "Sub Category" },
      ],
      label_corrective_action: [
        { value: "problem_detail", text: "สาเหตุ" },
        { value: "result_detail", text: "แก้ไข" },
      ],
      material_usage: [
        {
          title: "Material Name",
          dataIndex: "material_name",
          key: "material_name",
        },
        {
          title: "Warehouse",
          dataIndex: "wh_name",
          key: "wh_name",
        },
        {
          title: "Quantity",
          dataIndex: "qty",
          key: "qty",
        },
        {
          title: "Unit",
          dataIndex: "unit_code",
          key: "unit_code",
        },
        {
          title: "Serial Numebr",
          dataIndex: "",
          key: "",
          render: (item) =>
            item.material_name === null
              ? []
              : JSON.parse(item.serial_no) === null
                ? []
                : JSON.parse(item.serial_no).map((value, index) => {
                  var display = "";
                  display += value + ",";
                  return index === JSON.parse(item.serial_no).length - 1
                    ? display.substring(0, display.length - 1)
                    : display;
                }),
        },

        {
          title: "Remark",
          dataIndex: "remark",
          key: "remark",
        },
      ],
      data_material_table: [],
      record_problem: [
        {
          title: "Job No.",
          dataIndex: "",
          key: "",
        },
        {
          title: "Job category",
          dataIndex: "",
          key: "",
        },
        {
          title: "Date",
          dataIndex: "",
          key: "",
        },
        {
          title: "Service Type",
          dataIndex: "",
          key: "",
        },
        {
          title: "New Type",
          dataIndex: "",
          key: "",
        },
        {
          title: "Sub Category",
          dataIndex: "",
          key: "",
        },
        {
          title: "Maintenance By",
          dataIndex: "",
          key: "",
        },
      ],
      colum_total_status: [
        {
          title: "Emp Name",
          dataIndex: "emp_name",
          key: "emp_name",
        },
        {
          title: "Process Name",
          dataIndex: "process_name",
          key: "process_name",
        },
        {
          title: "Log Message",
          dataIndex: "log_message",
          key: "log_message",
        },
        {
          title: "Total Day",
          dataIndex: "total_days",
          key: "total_days",
        },
        {
          title: "Total Hour",
          dataIndex: "total_hour",
          key: "total_hour",
        },
        {
          title: "Total Min",
          dataIndex: "total_min",
          key: "total_min",
        },
      ],
      data_total_status: [],
      total_time: [],
      result_damage_detail: [],
      label_check_list: [],
      colum_check_list: [
        {
          title: "รายละเอียด",
          dataIndex: "job_checklist_name",
          key: "job_checklist_name",
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip placement="topLeft" title={item}>
              {item}
            </Tooltip>
          ),
        },
        {
          title: "Check Box",
          dataIndex: "oper_job_checklist_status",
          key: "oper_job_checklist_status",
          align: "center",
          render: (item) => (item === 1 ? "ปกติ" : "ไม่ปกติ"),
        },
        {
          title: "หมายเหตุ",
          dataIndex: "oper_job_checklist_remark",
          key: "oper_job_checklist_remark",
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip placement="topLeft" title={item}>
              {item}
            </Tooltip>
          ),
        },
        {
          title: "รูปถ่าย",
          dataIndex: "",
          key: "",
          render: (item) => (
            <div className="row">
              {item.checklist_pic.map((data, index) => {
                return index > 2 ? (
                  index === 3 ? (
                    <>
                      <div className="col-auto">
                        <Image
                          // className="ml-1"
                          style={{ cursor: "pointer" }}
                          width={50}
                          height={50}
                          src={Api.absoluteUrl("/icon/see_more.png")}
                        />
                      </div>
                    </>
                  ) : null
                ) : data.pic_source_type.toLowerCase() === ".jpg" ||
                  data.pic_source_type.toLowerCase() === ".png" ||
                  data.pic_source_type.toLowerCase() === ".jpeg" ||
                  data.pic_source_type.toLowerCase() === ".svg" ? (
                  <div className="col-auto">
                    <Image
                      // className="ml-1"
                      style={{ cursor: "pointer" }}
                      width={50}
                      height={50}
                      src={Api.checkPath(
                        data.pic_url_path,
                        data.pic_upload_name
                      )}
                    />
                  </div>
                ) : (
                  <div className="col-auto">
                    <video
                      width="75"
                      controls
                      // className="ml-1 mb-1 mr-1"
                      style={{ height: "60px" }}
                    >
                      <source
                        src={Api.checkPath(
                          data.pic_url_path,
                          data.pic_upload_name
                        )}
                        type="video/mp4"
                      ></source>
                    </video>
                  </div>
                );
              })}
            </div>
          ),
        },
      ],
      data_check_list: [],
      visible_checklist: false,
      display_remark: "",
      visible_modal_image: false,
      /* add for uih */
      company_id: Cookies.get("companyid"),
      /* stoptime approval */
      visible_stoptime: false,
      getFulldetail: null,
      approval_visible: false,
      approval_flag: 0,
      stoptimereason: [],
      fileList: [],
      displayImage: "",
      checkNext: true
    };
  }
  async componentDidMount() {
    this.onLoadData();
  }

  async onLoadData() {
    this.setState({
      factupdate: false
    })
    const reject_reason_list = await Api.post(
      "get_servicemareasonstoptime_v2",
      {
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        ma_reason: "STOPTIME",
      }
    );

    const getFulldetail = await Api.post("get_fulldetail_job_ma_V2", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      job_id: Cookies.get("job_id"),
      job_progress_id: Cookies.get("job_progress_id"),
    });

    this.setState({
      stoptimereason: reject_reason_list.data.data.serult_service_reason,
      jobdetail_for_timestop: getFulldetail.data.data,
    });

    var subProcessID =
      getFulldetail.data.data.result_maintenance.length === 0
        ? "-1"
        : getFulldetail.data.data.result_maintenance[0].subProcessID;
    const getBtn = await Api.post("getButtonDetailWeb", {
      WF_ID: getFulldetail.data.data.result_maintenance[0].wf_id,
      CompanyID: Cookies.get("companyid"),
      ProjectID: Cookies.get("project_id"),
      JobTypeID: getFulldetail.data.data.result_maintenance[0].jobtypeid,
      MainProcessID:
        getFulldetail.data.data.result_maintenance[0].mainProcessID,
      SubProcessID: subProcessID,
      ActionID:
        getFulldetail.data.data.result_maintenance[0].next_main_action_id,
      UserName: Cookies.get("username"),
      operator_id: Cookies.get("operator_id"),
    });

    const getmaterial = await Api.post("getMatDetailDataGetJob", {
      stock_main_id: "",
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      job_id: Cookies.get("job_id"),
    });
    // data_material_table

    if (
      getFulldetail.data.data.result_maintenance[0].subProcessID === -1 &&
      getFulldetail.data.data.result_maintenance[0].mainProcessID === 31
    ) {
      this.setState({
        check_approve: true,
      });
    }
    this.setState({
      getFulldetail: getFulldetail,
      check_stop_time:
        (getFulldetail.data.data.result_maintenance[0].mainProcessID === 3 &&
          getFulldetail.data.data.result_maintenance[0].subProcessID === 18) ||
          getFulldetail.data.data.result_maintenance[0].subProcessID === 20 ||
          getFulldetail.data.data.result_maintenance[0].subProcessID === 21
          ? true
          : false,
      display_stop_time:
        getFulldetail.data.data.result_maintenance[0].job_status_name,
      display_stop_time_detail:
        getFulldetail.data.data.result_maintenance[0].job_stop_id,
      Workflow: getBtn.data.result.value === "F" ? [] : getBtn,
      data_material_table: getmaterial.data.data.result,
      display_remark:
        getmaterial.data.data.remark.length === 0
          ? ""
          : getmaterial.data.data.remark[0],
      /* not working comment by dr.copyman*/
      total_time: getFulldetail.data.data.result_total_time,
    });

    /**change language */
    const change_lang = await Api.post("master_language_detail_get", {
      company_id: Cookies.get("companyid"),
      page_id: 1,
    });
    this.setState({
      data_translate: JSON.parse(
        change_lang.data.data["masteR_LANGUAGE_DETAIL"][0].file_json
      ),
    });
    /**end change language */
    const setStep =
      getFulldetail.data.data.result_maintenance[0].subProcessID === -1 &&
        getFulldetail.data.data.result_maintenance[0].mainProcessID === 31
        ? getFulldetail.data.data.result_maintenance[0].from_main_process_id
        : getFulldetail.data.data.result_maintenance[0].from_main_process_id ===
          18 ||
          getFulldetail.data.data.result_maintenance[0].mainProcessID === 18 ||
          getFulldetail.data.data.result_maintenance[0].job_status_name ===
          "Wait Assign"
          ? 0
          : getFulldetail.data.data.result_maintenance[0].from_main_process_id -
          1;

    this.setState({
      loading: false,
      asset:
        getFulldetail.data.data.result_assetdetail.length > 0
          ? getFulldetail.data.data.result_assetdetail[0]
          : [],
      data_mainttenance:
        getFulldetail.data.data.result_maintenance.length > 0
          ? getFulldetail.data.data.result_maintenance[0]
          : [],
      dynamic_state: getFulldetail.data.data.result_maintenance[0].data_dynamic,
      clonedynamic_state: JSON.parse(
        getFulldetail.data.data.result_maintenance[0].data_dynamic
      ),
      dynamic_cancel:
        getFulldetail.data.data.result_maintenance[0].data_dynamic,
      data_assignment:
        getFulldetail.data.data.result_assignment.length > 0
          ? getFulldetail.data.data.result_assignment[0]
          : [],
      data: {
        name: getFulldetail.data.data.result_maintenance[0].location_name,
      },
      active_step: setStep,
      check_job_status:
        getFulldetail.data.data.result_maintenance[0].job_status,
      Inform_Person: "TEST",
      InformDate: "In Form Date Test",
      data_material: {
        modal_material: "-",
        power_supply: "-",
        receiving_card: "-",
        sending: "-",
        hub: "-",
        tv: "-",
        other: "-",
      },
      set_pic: getFulldetail.data.data.result_oper_job_pic,
      data_total_status: getFulldetail.data.data.result_job_log,
    });
    document.title =
      getFulldetail.data.data.result_maintenance[0].location_name;
    var setemp_team = [];
    for (var i = 0; i < getFulldetail.data.data.result_assignment.length; i++) {
      setemp_team.push(getFulldetail.data.data.result_assignment[i].mtn_name);
    }
    this.setState({
      Team_name: setemp_team,
      factupdate: true,
      result_damage_detail: getFulldetail.data.data.result_damage_detail,
    });
  }
  async onApprove() {
    var chekFlowM = this.state.Workflow.data.return_nextWorkFlow.filter(
      (element) =>
        element.next_flow === "M" &&
        element.next_main_process_name === "Complete"
    );
    var dataset = {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      job_id: this.state.getFulldetail.data.data.result_maintenance[0].job_id,
      job_progress_id:
        this.state.getFulldetail.data.data.result_maintenance[0]
          .job_progress_id,
      create_by: Cookies.get("username"),
      jobtypeid:
        this.state.getFulldetail.data.data.result_maintenance[0].jobtypeid,
      progress_Status_flag: "",
      checkFlag: 1,
      reject_reason_id: "",
      approve_remark: "",
      ...chekFlowM[0],
    };
    this.setState({
      dataapprove: [dataset],
      visible_modal_approve: true,
    });
  }
  async onReject() {
    const selectReject = await Api.post("get_servicemareasonstoptime_v2", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      ma_reason: "REJECT",
    });
    this.setState({
      maseter_reject: selectReject.data.data.serult_service_reason,
      visible_modal_reject: true,
    });
  }
  handleCancel() {
    this.setState((prevState) => {
      let visible = Object.assign({}, prevState.visible);
      visible.approve = false;
      visible.reject = false;
      visible.approve_success = false;
      visible.reject_success = false;
      return { visible };
    });
  }
  async handleGivenScoreCancel() {
    this.setState({
      visible_modal_approve: false,
    });
  }
  checkVisibleModalGiveScore(isVisible) {
    this.setState({
      visible_modal_approve: isVisible,
    });
  }

  async handleGivenScoreOK() {
    this.setState({
      visible_modal_approve: false,
    });
  }
  async handleSubmitApprove() {
    const getFulldetail = await Api.post("updatejobstatusprogress", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      job_id: this.state.data_mainttenance.job_id,
      job_progress_id: this.state.data_mainttenance.job_progress_status,
      action_id: 7,
      job_status: this.state.data_mainttenance.job_status,
      progress_status: this.state.data_mainttenance.job_progress_status,
      update_by: 3,
      location_lat: null,
      location_long: null,
    });
    if (getFulldetail.data.result.value.toLowerCase() === "p") {
      this.setState((prevState) => {
        let visible = Object.assign({}, prevState.visible);
        let active_step = Object.assign({}, prevState.active_step);
        visible.approve = false;
        visible.reject = false;
        visible.approve_success = true;
        visible.reject_success = false;
        active_step = 6;
        return { visible, active_step };
      });
      window.location = "/MaxiOperation/ma_list/";
    } else {
      alert("Approve Error");
    }
  }
  async handleSubmitReject(values) {
    const { fileList } = this.state;
    const formData = new FormData();
    this.setState({ visible_modal_reject: false });
    var chekFlowM = this.state.Workflow.data.return_nextWorkFlow.filter(
      (element) =>
        element.next_flow === "M" && element.next_main_action_name === "Reject"
    );
    var dataset = {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      job_id: this.state.getFulldetail.data.data.result_maintenance[0].job_id,
      job_progress_id:
        this.state.getFulldetail.data.data.result_maintenance[0]
          .job_progress_id,
      create_by: Cookies.get("username"),
      jobtypeid:
        this.state.getFulldetail.data.data.result_maintenance[0].jobtypeid,
      progress_Status_flag: "",
      checkFlag: 0,
      reject_reason_id: this.state.form["Reason"],
      approve_remark: this.state.form["remark"],
      ...chekFlowM[0],
    };
    const RejectJob = await Api.post("update_oper_job_approve_finish", dataset);
    if (RejectJob.data.result.code === "P") {
      fileList.forEach((file) => {
        formData.append("files", file["originFileObj"]);
        formData.append(
          "job_id",
          this.state.getFulldetail.data.data.result_maintenance[0].job_id
        );
        formData.append(
          "job_progress_id",
          this.state.getFulldetail.data.data.result_maintenance[0]
            .job_progress_id
        );
        formData.append("company_id", Cookies.get("companyid"));
        formData.append("operator_id", Cookies.get("operator_id"));
        formData.append("project_id", Cookies.get("project_id"));
        formData.append(
          "job_category_id",
          this.state.getFulldetail.data.data.result_checklist[0].job_category_id
        );
        formData.append(
          "job_type_id",
          this.state.getFulldetail.data.data.result_maintenance[0].jobtypeid
        );
        formData.append(
          "asset_id",
          this.state.getFulldetail.data.data.result_assetdetail[0].asset_id
        );
        formData.append("create_by", Cookies.get("username"));
        formData.append("pic_type", "X");
        formData.append("job_reference_id", "");
      });
      if (fileList.length > 0) {
        await axios({
          method: "post",
          url:
            process.env.REACT_APP_URL_API + "job_detail/InsertImageListFile/",
          data: formData,
          headers: {
            TokenUser: Cookies.get(`OperationToken`),
          },
          processData: false,
        })
          .then(function (response) {
            for (let i = 0; i < formData.getAll("files").length; i++) {
              formData.delete("files");
              formData.delete("job_id");
              formData.delete("job_progress_id");
              formData.delete("company_id");
              formData.delete("operator_id");
              formData.delete("project_id");
              formData.delete("job_category_id");
              formData.delete("job_type_id");
              formData.delete("asset_id");
              formData.delete("create_by");
              message.success("upload successfully.");
            }
          })
          .catch(function (response) {
            console.log(response);
          });
      } else {
        this.setState({
          checkbtn: true,
          modalstatus: true,
        });
      }
      this.setState({
        visible_modal_reject_status: true,
      });
    }
  }
  handleSubmitDetail(values) {
    const { dynamic_state } = this.state;
    let temp_dynamic = JSON.parse(dynamic_state);

    Object.keys(temp_dynamic).forEach(function (key) {
      Object.keys(values).forEach(function (key2) {
        if (key === key2) {
          temp_dynamic[key] = values[key];
        }
      });
    });

    this.setState({
      visibleDrawer: false,
      dynamic_state: JSON.stringify(temp_dynamic),
    });
  }
  handleDataTable(data, table) {
    const { dynamic_state } = this.state;
    let temp_dynamic = JSON.parse(dynamic_state);

    temp_dynamic[table] = data;
    this.setState({
      dynamic_state: JSON.stringify(temp_dynamic),
    });
  }
  renderOnprocess() {
    return (
      <Fragment>
        <div>
          <span className="font-thai-i font18">ส่วนรายละเอียดจากช่าง</span>
        </div>
        <div className="text-center" style={{ margin: "40px 0" }}>
          <div className="mb-2">
            <img src={Api.absoluteUrl("/img/on_process.svg")} />
          </div>
          <span className="font-thai-i font18">กำลังดำเนินงานซ่อม</span>
        </div>
      </Fragment>
    );
  }
  CheckListDisplay = async () => {
    const checklist = await Api.post("v2/get_checklist_map", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      job_id: this.state.getFulldetail.data.data.result_maintenance[0].job_id,
    });
    this.setState({
      label_check_list: [
        {
          value: checklist.data.data[0].job_checklist_group_name,
          text: "Check List ID",
        },
        {
          value: checklist.data.data[0].job_category_name,
          text: "Job Category",
        },
        // { value: "sla_name", text: "Department" },
        { value: checklist.data.data[0].job_type_name, text: "Job Type" },
        // { value: this.state.getFulldetail.data.data.result_maintenance[0].userName, text: "Created By" },
        {
          value: checklist.data.data[0].job_sub_type_name,
          text: "Job Sub Type",
        },
      ],
      visible_checklist: true,
      data_check_list: checklist.data.data,
    });
  };
  rendermainternence_report() {
    return (
      <div className="row">
        <div className="col-6">
          <img
            src={Api.absoluteUrl("/icon/damage_check.svg")}
            className="mr-2"
          />
          <span className="font-thai-b font22 c-blue">
            {/* {this.state.Inform_Person} */}
            {"Damage Check"}
          </span>
        </div>
        <div className="col-6">
          <img
            src={Api.absoluteUrl("/icon/damage_check.svg")}
            className="mr-2"
          />
          <span className="font-thai-b font22 c-blue">
            {/* {this.state.Inform_Person} */}
            {"Corrective action"}
          </span>
        </div>
        <div className="col-6">
          <div
            className="full-detail-job-des"
            style={{ margin: "0 20px", borderLeft: "2px solid #fff" }}
          >
            {this.state.label_damage_check.map((value, index) => {
              return (
                <div className="row">
                  <div className="col-6">
                    <span className="font-thai-b font18">
                      {this.state.factupdate ? (
                        <span className="font-thai-b font18">
                          {value.text}
                          {/* {
                                        this.state.data_translate[
                                          Cookies.get("locale")
                                        ]["inform_detail"]
                                      } */}
                        </span>
                      ) : null}
                    </span>
                  </div>
                  <div className="col-6 pl-0">
                    <span
                      className="font-thai-sb font18 c-blue"
                      style={{ wordBreak: "break-word" }}
                    >
                      {this.state.result_damage_detail.length === 0
                        ? "-"
                        : this.state.result_damage_detail[0][value.value] ===
                          "not found id" ||
                          this.state.result_damage_detail[0][value.value] ===
                          null ||
                          this.state.result_damage_detail[0][value.value] ===
                          undefined
                          ? "-"
                          : this.state.result_damage_detail[0][value.value]}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="col-6">
          <div
            className="full-detail-job-des"
            style={{ margin: "0 20px", borderLeft: "2px solid #fff" }}
          >
            {this.state.label_corrective_action.map((value, index) => {
              return (
                <div className="row">
                  <div className="col-6">
                    <span className="font-thai-b font18">
                      {this.state.factupdate ? (
                        <span className="font-thai-b font18">{value.text}</span>
                      ) : null}
                    </span>
                  </div>
                  <div className="col-6 pl-0">
                    <span
                      className="font-thai-sb font18 c-blue"
                      style={{ wordBreak: "break-word" }}
                    >
                      {this.state.data_mainttenance[value.value] || "-"}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="col-12 mt-2">
          <img
            src={Api.absoluteUrl("/icon/damage_check.svg")}
            className="mr-2"
          />
          <span className="font-thai-b font22 c-blue">
            {/* {this.state.Inform_Person} */}
            {"Material Usage"}
          </span>
          <span
            className="font-thai-b font16 ml-4"
            style={{ color: "#6F6F6F", letterSpacing: "0.36px" }}
          >
            {/* {"เปลี่ยนอะไหล่ หรือ ไม่เปลี่ยนอะไหล่"} */}
          </span>
        </div>
        <div className="col-12 mt-3 mb-3">
          <Table
            // scroll={{ x: 1300, y: 500 }}
            columns={this.state.material_usage}
            dataSource={this.state.data_material_table}
            pagination={false}
            style={{
              whiteSpace: "nowrap",
              lineHeight: "1 !important",
            }}
          />
          <textarea
            style={{
              width: "100%",
              height: "50px",
              marginTop: "10px",
              padding: "5px",
            }}
            name="inform_remark"
            placeholder="Note / Comment"
            disabled={true}
            defaultValue={
              this.state.display_remark === undefined
                ? "Note / Comment"
                : this.state.display_remark.remark
            }
          // onChange={this.handleInputChange}
          ></textarea>
        </div>
        <div className="col-6">
          <img src={Api.absoluteUrl("/icon/check_list.svg")} className="mr-2" />
          <span
            className="font-thai-b font22 c-blue"
            style={{ marginLeft: "6px" }}
          >
            {"Check List"}
          </span>
          <a
            href="#"
            className="font-thai-b font16 ml-4"
            style={{ color: "#6F6F6F", letterSpacing: "0.36px" }}
            onClick={() => this.CheckListDisplay()}
          >
            {this.state.getFulldetail.data.data.result_checklist.length === 0
              ? " - "
              : this.state.getFulldetail.data.data.result_checklist[0]
                .job_check_list_type}
            {/* test */}
          </a>
        </div>
        <div className="col-6">
          <span
            className="font-thai-b font22 c-blue"
            style={{ marginLeft: "26px" }}
          >
            {"Request Close Date"}
          </span>

          <span
            className="font-thai-b font16 ml-4"
            style={{ color: "#6F6F6F", letterSpacing: "0.36px" }}
          >
            {/* {this.state.Inform_Person} */}
            {this.state.factupdate === true ? (
              <>
                {this.state.getFulldetail.data.data.result_maintenance[0]
                  .request_close_date != null
                  ? moment(
                    this.state.getFulldetail.data.data.result_maintenance[0]
                      .request_close_date
                  ).format("DD/MM/YYYY HH:mm:s")
                  : "-"}
              </>
            ) : null}
          </span>
        </div>
        {/* <div className="col-6"></div> */}
        <div className="col-6">
          <img
            src={Api.absoluteUrl("/icon/status_time.svg")}
            className="mr-2"
          />
          <span className="font-thai-b font22 c-blue">
            {/* {this.state.Inform_Person} */}
            {"Start Time"}
          </span>

          <span
            className="font-thai-b font16 ml-4"
            style={{ color: "#6F6F6F", letterSpacing: "0.36px" }}
          >
            {/* {this.state.Inform_Person} */}
            {this.state.factupdate === true
              ? moment(
                this.state.getFulldetail.data.data.result_maintenance[0]
                  .v_create_date
              ).format("HH:mm:ss") +
              " - " +
              moment(
                this.state.getFulldetail.data.data.result_total_time[0]
                  .v_last_date
              ).format("HH:mm:ss")
              : null}
          </span>
        </div>
        <div className="col-6">
          {/* <img
            src={Api.absoluteUrl("/icon/status_time.svg")}
            className="mr-2"
          /> */}
          <span
            className="font-thai-b font22 c-blue"
            style={{ marginLeft: "26px" }}
          >
            {/* {this.state.Inform_Person} */}
            {"Total Time"}
          </span>
          <span
            className="font-thai-b font16 ml-4"
            style={{ color: "#6F6F6F", letterSpacing: "0.36px" }}
          >
            {this.state.total_time[0].days}
            {" Day "}
            {this.state.total_time[0].hours}
            {" Hours "}
            {this.state.total_time[0].min}
            {" Min "}
          </span>
        </div>

        <div className="col-6">
          <img
            src={Api.absoluteUrl("/icon/status_report.svg")}
            className="mr-2"
          />
          <span
            className="font-thai-b font22 c-blue"
            style={{ marginLeft: "6px" }}
          >
            {"Status Report"}
          </span>
        </div>
        <div className="col-12 mt-2 mb-2">
          <Table
            columns={this.state.colum_total_status}
            dataSource={this.state.data_total_status}
            pagination={false}
          />
        </div>

        <div className="col-12 mt-2">
          <img
            src={Api.absoluteUrl("/icon/attach_phoyo(before).svg")}
            className="mr-2"
          />
          <span className="font-thai-b font22 c-blue">
            {/* {this.state.Inform_Person} */}
            {"Attach a photo (Before)"}
          </span>
        </div>
        <div className="col-12 mt-2">
          <div className="row mt-2">
            {this.state.set_pic.map((data, index) => {
              return (
                <>
                  {(data.pic_upload_type.toLowerCase() === ".jpg" ||
                    data.pic_upload_type.toLowerCase() === ".png" ||
                    data.pic_upload_type.toLowerCase() === ".jpeg" ||
                    data.pic_upload_type.toLowerCase() === ".svg") &&
                    data.pic_type === "N" ? (
                    <div class="col-auto">
                      <Image
                        className="ml-1 mb-1"
                        style={{ cursor: "pointer" }}
                        width={150}
                        height={80}
                        src={Api.checkPath(
                          data.pic_url_path,
                          data.pic_upload_name
                        )}
                      />
                    </div>
                  ) : (data.pic_upload_type.toLowerCase() === ".mp4" ||
                    data.pic_upload_type.toLowerCase() === ".avi" ||
                    data.pic_upload_type.toLowerCase() === ".mov" ||
                    data.pic_upload_type.toLowerCase() === ".wmv") &&
                    data.pic_type === "N" ? (
                    <div class="col-auto">
                      <video
                        width="150"
                        controls
                        className="ml-1 mb-1 mr-1"
                        style={{ height: "80px" }}
                      >
                        <source
                          src={Api.checkPath(
                            data.pic_url_path,
                            data.pic_upload_name
                          )}
                          type="video/mp4"
                        ></source>
                      </video>
                    </div>
                  ) : (data.pic_upload_type.toLowerCase() === ".pdf" ||
                    data.pic_upload_type.toLowerCase() === ".xlsx" ||
                    data.pic_upload_type.toLowerCase() === ".xls" ||
                    data.pic_upload_type.toLowerCase() === ".doc" ||
                    data.pic_upload_type.toLowerCase() === ".txt") &&
                    data.pic_type === "N" ? (
                    <div class="col-auto">
                      <a
                        href={Api.checkPath(
                          data.pic_url_path,
                          data.pic_upload_name
                        )}
                        download
                      >
                        <CopyOutlined style={{ marginRight: "5px" }} />

                        {data.pic_upload_name}
                      </a>
                    </div>
                  ) : null}
                </>
              );
            })}
          </div>
        </div>
        <div className="col-12 mt-2">
          <img src={Api.absoluteUrl("/icon/add-folder.svg")} className="mr-2" />
          <span className="font-thai-b font22 c-blue">
            {/* {this.state.Inform_Person} */}
            {"Attachment (After)"}
          </span>
        </div>

        <div className="col-12 mt-2">
          <div className="row mt-2">
            {this.state.set_pic.map((data, index) => {
              return (
                <>
                  {(data.pic_upload_type.toLowerCase() === ".jpg" ||
                    data.pic_upload_type.toLowerCase() === ".png" ||
                    data.pic_upload_type.toLowerCase() === ".jpeg" ||
                    data.pic_upload_type.toLowerCase() === ".svg") &&
                    data.pic_type === "Y" ? (
                    <div class="col-auto">
                      <Image
                        className="ml-1 mb-1"
                        style={{ cursor: "pointer" }}
                        width={150}
                        height={80}
                        src={Api.checkPath(
                          data.pic_url_path,
                          data.pic_upload_name
                        )}
                      />
                    </div>
                  ) : (data.pic_upload_type.toLowerCase() === ".mp4" ||
                    data.pic_upload_type.toLowerCase() === ".avi" ||
                    data.pic_upload_type.toLowerCase() === ".mov" ||
                    data.pic_upload_type.toLowerCase() === ".wmv") &&
                    data.pic_type === "Y" ? (
                    <div class="col-auto">
                      <video
                        width="150"
                        controls
                        className="ml-1 mb-1 mr-1"
                        style={{ height: "80px" }}
                      >
                        <source
                          src={Api.checkPath(
                            data.pic_url_path,
                            data.pic_upload_name
                          )}
                          type="video/mp4"
                        ></source>
                      </video>
                    </div>
                  ) : (data.pic_upload_type.toLowerCase() === ".pdf" ||
                    data.pic_upload_type.toLowerCase() === ".xlsx" ||
                    data.pic_upload_type.toLowerCase() === ".xls" ||
                    data.pic_upload_type.toLowerCase() === ".doc" ||
                    data.pic_upload_type.toLowerCase() === ".txt") &&
                    data.pic_type === "Y" ? (
                    <div class="col-auto">
                      <a
                        href={Api.checkPath(
                          data.pic_url_path,
                          data.pic_upload_name
                        )}
                        download
                      >
                        <CopyOutlined style={{ marginRight: "5px" }} />

                        {data.pic_upload_name}
                      </a>
                    </div>
                  ) : null}
                </>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
  renderCustomerReport() {
    return <Fragment />;
  }
  renderModalApprove(status) {
    return (
      <Modal
        title={null}
        centered
        visible={status}
        footer={null}
        closable={false}
      >
        <div className="text-center">
          <img
            src={Api.absoluteUrl("/img/modal_approve.svg")}
            className="img-fluid"
          />
          <h3 className="font-mont-sb font18 c-blue mt-3">
            Are you sure to close this job
          </h3>
          <button
            onClick={() => this.handleCancel()}
            className="btn btn-secondary"
          >
            Cancel
          </button>
          <button
            onClick={() => this.handleSubmitApprove()}
            className="btn btn-success"
          >
            Confirm
          </button>
        </div>
      </Modal>
    );
  }
  renderModalReject(status) {
    return (
      <Modal
        title={<span className="font-mont-sb font18 c-blue">Reject</span>}
        centered
        visible={status}
        footer={null}
        closable={false}
      >
        <Form
          onFinish={(values) => this.handleSubmitReject(values)}
          layout="vertical"
        >
          <Form.Item
            name="reason"
            label={<div className="font-mont-m font12">Reason</div>}
            rules={[
              {
                required: true,
                message: "โปรดเขียนรายละเอียด",
              },
            ]}
          >
            <Input.TextArea rows={4} placeholder="เขียนรายละเอียด" />
          </Form.Item>
          <Form.Item className="mb-0 text-center">
            <button
              type="reset"
              onClick={() => this.handleCancel()}
              className="btn btn-secondary"
            >
              Cancel
            </button>
            <button className="btn btn-danger">Reject</button>
          </Form.Item>
        </Form>
      </Modal>
    );
  }
  renderModalApproveSuccess(status) {
    return (
      <Modal
        title={null}
        centered
        visible={status}
        footer={null}
        closable={false}
      >
        <div className="text-center">
          <img
            src={Api.absoluteUrl("/img/modal_success.svg")}
            className="img-fluid"
          />
          <h3 className="font-mont-sb font18 c-blue mt-3">
            Close Job Successful
          </h3>
          <button
            className="btn btn-primary"
            onClick={() => this.handleCancel()}
          >
            Ok
          </button>
        </div>
      </Modal>
    );
  }
  setFormsView(data) {
    const form_json = [];
    const form_json_parse = JSON.parse(data["form_json"]);
    for (let x in form_json_parse[data["table_name"]]) {
      form_json.push(form_json_parse[data["table_name"]][x]);
    }
    return form_json;
  }
  async onMoreDetail() {
    const { visibleDrawer, current_page, dataConfDynamic, jsonOutput } =
      this.state;
    const companyid = Cookies.get(`companyid`);

    const dataMasFormJsonDetail =
      jsonOutput["data"]["data"]["mas_form_json_dto_list"][0];

    dataMasFormJsonDetail["language_name"] = Array.isArray(
      dataMasFormJsonDetail["language_name"]
    )
      ? dataMasFormJsonDetail["language_name"]
      : dataMasFormJsonDetail["language_name"].split(",");

    dataMasFormJsonDetail["language"] = Array.isArray(
      dataMasFormJsonDetail["language"]
    )
      ? dataMasFormJsonDetail["language"]
      : dataMasFormJsonDetail["language"].split(",");

    dataMasFormJsonDetail["forms"] = Array.isArray(
      dataMasFormJsonDetail["forms"]
    )
      ? dataMasFormJsonDetail["forms"]
      : this.setFormsView(dataMasFormJsonDetail);

    this.setState({
      visibleDrawer: true,
      dataMasFormJsonDetail: dataMasFormJsonDetail,
    });
  }
  renderDrawer() {
    const {
      visibleDrawer,
      dataMasFormJsonDetail,
      dataJSON,
      lang,
      data_mainttenance,
      dynamic_state,
    } = this.state;
    const forms =
      dataMasFormJsonDetail.forms !== undefined
        ? dataMasFormJsonDetail.forms
        : [];
    const language =
      dataMasFormJsonDetail.language !== undefined
        ? dataMasFormJsonDetail.language
        : [];
    const language_name =
      dataMasFormJsonDetail.language_name !== undefined
        ? dataMasFormJsonDetail.language_name
        : [];

    const data_dynamic = JSON.parse(dynamic_state);
    return (
      <Drawer
        title={
          <span className="font-mont-b font16 c-blue text-uppercase">
            More Detail
          </span>
        }
        width={900}
        closable={false}
        onClose={this.onClose}
        visible={visibleDrawer}
      >
        <Form
          onFinish={(values) => this.handleSubmitDetail(values)}
          layout="vertical"
          initialValues={data_dynamic}
        >
          <div className="row justify-content-center">
            <div className="col-12">
              {/* <Form layout="vertical"> */}
              {forms.map((field, index) => {
                if (field.input !== undefined) {
                  if (field.input["type"] === "radio") {
                    return (
                      <Form.Item
                        key={index}
                        name={field.label["EN"]["for"]}
                        label={field.label[lang]["text"]}
                        rules={[
                          {
                            required: field.input["required"],
                            message: `${field.label["EN"]["text"]} is required`,
                          },
                        ]}
                      >
                        <Radio.Group options={field.option} />
                      </Form.Item>
                    );
                  } else if (field.input["type"] === "checkbox") {
                    return (
                      <Form.Item
                        key={index}
                        name={field.label["EN"]["for"]}
                        label={field.label[lang]["text"]}
                        rules={[
                          {
                            required: field.input["required"],
                            message: `${field.label["EN"]["text"]} is required`,
                          },
                        ]}
                      >
                        <Checkbox.Group options={field.option} />
                      </Form.Item>
                    );
                  } else if (field.input["type"] === "date") {
                    return (
                      <Form.Item
                        key={index}
                        name={field.label["EN"]["for"]}
                        label={field.label[lang]["text"]}
                        rules={[
                          {
                            required: field.input["required"],
                            message: `${field.label["EN"]["text"]} is required`,
                          },
                        ]}
                      >
                        <DatePicker format="DD/MM/YYYY" />
                      </Form.Item>
                    );
                  } else if (field.input["type"] === "datetime-local") {
                    return (
                      <Form.Item
                        key={index}
                        name={field.label["EN"]["for"]}
                        label={field.label[lang]["text"]}
                        rules={[
                          {
                            type: "object",
                            required: field.input["required"],
                            message: `${field.label["EN"]["text"]} is required`,
                          },
                        ]}
                      >
                        <DatePicker showTime format="DD/MM/YYYY HH:mm:ss" />
                      </Form.Item>
                    );
                  } else if (field.input["type"] === "password") {
                    return (
                      <Form.Item
                        key={index}
                        name={field.label["EN"]["for"]}
                        label={field.label[lang]["text"]}
                        rules={[
                          {
                            type: "object",
                            required: field.input["required"],
                            message: `${field.label["EN"]["text"]} is required`,
                          },
                        ]}
                      >
                        <Input.Password
                          placeholder={`Please input ${field.label["EN"][
                            "text"
                          ].toLowerCase()}`}
                        />
                      </Form.Item>
                    );
                  } else {
                    return (
                      <Form.Item
                        key={index}
                        name={field.label["EN"]["for"]}
                        label={field.label[lang]["text"]}
                        rules={[
                          {
                            required: field.input["required"],
                            message: `${field.label["EN"]["text"]} is required`,
                          },
                        ]}
                      >
                        <Input
                          type={field.input["type"]}
                          className="font-mont-r font12"
                          size="large"
                          placeholder={`Please input ${field.label["EN"][
                            "text"
                          ].toLowerCase()}`}
                        // pattern={
                        //   field.input["pattern"] !== undefined
                        //     ? field.input["pattern"]
                        //     : ""
                        // }
                        />
                      </Form.Item>
                    );
                  }
                } else if (field.select !== undefined) {
                  const options = field.option.map((d) => (
                    <Option key={d.value}>{d.label}</Option>
                  ));
                  return (
                    <Form.Item
                      key={index}
                      name={field.label["EN"]["for"]}
                      label={field.label[lang]["text"]}
                      rules={[
                        {
                          required: field.select["required"],
                          message: `${field.select["text"]} is required`,
                        },
                      ]}
                    >
                      <Select
                        className="font-mont-r font12"
                        size="large"
                        placeholder={`Please select ${field.label["EN"][
                          "text"
                        ].toLowerCase()}`}
                      >
                        {options}
                      </Select>
                    </Form.Item>
                  );
                } else if (field.textarea !== undefined) {
                  return (
                    <Form.Item
                      key={index}
                      name={field.label["EN"]["for"]}
                      label={field.label[lang]["text"]}
                      rules={[
                        {
                          required: field.textarea["required"],
                          message: `${field.textarea["text"]} is required`,
                        },
                      ]}
                    >
                      <Input.TextArea />
                    </Form.Item>
                  );
                } else if (field.table !== undefined) {
                  let dynamic_col = [];
                  dataJSON.map((item, i) => {
                    if (item["label"][lang].for === field.table.id) {
                      dynamic_col = item["table"][lang]["columns"];
                    }
                  });

                  return (
                    <DynamicEditable
                      key={index}
                      col={dynamic_col}
                      table_id={field.table.id}
                      lang={lang}
                      data_dynamic={data_dynamic[field.table.id]}
                      parentUpdate={this.handleDataTable.bind(this)}
                    />
                  );
                }
              })}

              {/* </Form> */}
              <Form.Item className="mb-0 text-center">
                <div className="row">
                  <div className="col mt-2">
                    <button
                      type="reset"
                      onClick={() => this.setState({ visibleDrawer: false })}
                      className="btn btn-secondary mr-3"
                    >
                      Cancel
                    </button>
                    <button className="btn btn-success">Submit</button>
                  </div>
                </div>
              </Form.Item>
            </div>
          </div>
        </Form>
      </Drawer>
    );
  }
  handleCancelCheckList = (e) => {
    this.setState({
      visible_checklist: false,
    });
  };
  renderCheckList() {
    return (
      <Modal
        centered
        visible={this.state.visible_checklist}
        footer={null}
        closable={true}
        width={1000}
        destroyOnClose={true}
        onCancel={this.handleCancelCheckList}
        bodyStyle={{
          marginTop: "5%",
          paddingTop: "0",
          paddingLeft: "15px",
          paddingRight: "15px",
          paddingBottom: "0",
        }}
      >
        <div className="row">
          <div
            className="col"
            style={{
              backgroundColor: "#0500A3",
              height: "112px",
              borderBottom: "5px solid #EBCD00",
            }}
          >
            <div className="d-flex justify-content-between">
              <div className="col mt-5 ml-3">
                <img src={Api.absoluteUrl("/logo/Plan_B_logo.svg")} />
              </div>
              <div
                className="col-3 mt-4"
                style={{ color: "#FFFFFF", lineHeight: "2rem" }}
              >
                <div className="row">
                  <div className="col"></div>
                </div>
                <div className="row">
                  {/* <div className="col-12 mt-4 ml-3">Static Check List</div> */}
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-between">
              <div className="col-9"></div>
            </div>
          </div>
        </div>
        <div className="row mt-3 ml-1 mr-1">
          <div className="col">
            <div
              className="mb-3"
              style={{ fontSize: "28px", fontWeight: "bold", color: "#0500A3" }}
            >
              Check List
            </div>
            <div className="row">
              <div className="col-12">
                <div className="row">
                  {this.state.label_check_list.map((item, index) => (
                    <>
                      <div className="col-3">
                        {" "}
                        <span
                          style={{
                            color: "#42414A",
                            fontSize: "16px",
                            font: "normal normal bold 18px/24px ThaiSans Neue",
                          }}
                        >
                          {item.text}
                        </span>{" "}
                      </div>
                      <div className="col-3">
                        <span
                          style={{
                            color: "#0500A3",
                            fontSize: "14px",
                            font: "normal normal bold 18px/24px ThaiSans Neue",
                          }}
                        >
                          {item.value}
                        </span>
                      </div>
                    </>
                  ))}
                </div>
              </div>
            </div>
            <Table
              className="mb-3 mt-4"
              columns={this.state.colum_check_list}
              dataSource={this.state.data_check_list}
              pagination={false}
            />
          </div>
        </div>
      </Modal>
    );
  }
  handleChange = ({ fileList }) => this.setState({ fileList });
  handleCancel = () => this.setState({ previewVisible: false });
  handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
      previewTitle:
        file.name || file.url.substring(file.url.lastIndexOf("/") + 1),
    });
  };
  exportZip = async () => {
    var setFile = [];
    for (let i = 0; i < this.state.set_pic.length; i++) {
      const ImageTest = fetch(
        Api.checkPath(
          this.state.set_pic[i].pic_url_path,
          this.state.set_pic[i].pic_upload_name
        )
      ).then((val) => {
        let base_64 = val.blob().then((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(resolve);
          reader.onloadend = function () {
            const base64data = reader.result;
            var byteString = atob(base64data.split(",")[1]);
            var ab = new ArrayBuffer(byteString.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < byteString.length; i++) {
              ia[i] = byteString.charCodeAt(i);
            }
            const setFileName = val.url.split("/");
            const setTypeFile = setFileName[setFileName.length - 1].split(".");
            var fileType = "";
            if (
              setTypeFile[1] === "jpg" ||
              setTypeFile[1] === "gif" ||
              setTypeFile[1] === "eps" ||
              setTypeFile[1] === "png" ||
              setTypeFile[1] === "jpg" ||
              setTypeFile[1] === "raw" ||
              setTypeFile[1] === "heic"
            ) {
              fileType = "image/*";
            } else if (
              setTypeFile[1] === "mp4" ||
              setTypeFile[1] === "mp3" ||
              setTypeFile[1] === "mpeg" ||
              setTypeFile[1] === "wmv" ||
              setTypeFile[1] === "mov" ||
              setTypeFile[1] === "av"
            ) {
              fileType = "video/*";
            } else if (
              setTypeFile[1] === "pdf" ||
              setTypeFile[1] === "txt" ||
              setTypeFile[1] === "doc" ||
              setTypeFile[1] === "ppt" ||
              setTypeFile[1] === "xls" ||
              setTypeFile[1] === "xlsx" ||
              setTypeFile[1] === "prg" ||
              setTypeFile[1] === "dwg"
            ) {
              fileType = "application/*";
            }
            var blob_2 = new Blob([ia], {
              type: fileType,
            });
            var file = new File([blob_2], setFileName[setFileName.length - 1], {
              type: fileType,
            });
            setFile.push(file);
          };
        });
      });
    }
    setTimeout(() => {
      var o = 1,
        a = 1,
        n = 1,
        y = 1,
        s = 1,
        f = 1,
        p = 1,
        e = 1,
        z = 1,
        x = 1,
        t = 1;
      for (let i = 0; i < this.state.set_pic.length; i++) {
        switch (this.state.set_pic[i].pic_type) {
          case "O":
            zip
              .folder("Open Job")
              .file(
                this.state.asset.asset_id === "-1"
                  ? "No Asset" + o + this.state.set_pic[i].pic_source_type
                  : this.state.asset.asset_id +
                  o +
                  this.state.set_pic[i].pic_source_type,
                setFile[i]
              );
            o += 1;
            break;
          case "A":
            zip
              .folder("รูปจาก ASSET")
              .file(
                this.state.asset.asset_id === "-1"
                  ? "No Asset" + a + this.state.set_pic[i].pic_source_type
                  : this.state.asset.asset_id +
                  a +
                  this.state.set_pic[i].pic_source_type,
                setFile[i]
              );
            a += 1;
            break;
          case "N":
            zip
              .folder("ก่อนการซ่อม")
              .file(
                this.state.asset.asset_id === "-1"
                  ? "No Asset" + n + this.state.set_pic[i].pic_source_type
                  : this.state.asset.asset_id +
                  n +
                  this.state.set_pic[i].pic_source_type,
                setFile[i]
              );
            n += 1;
            break;
          case "Y":
            zip
              .folder("หลังการซ่อม")
              .file(
                this.state.asset.asset_id === "-1"
                  ? "No Asset" + y + this.state.set_pic[i].pic_source_type
                  : this.state.asset.asset_id +
                  y +
                  this.state.set_pic[i].pic_source_type,
                setFile[i]
              );
            y += 1;
            break;
          case "S":
            zip
              .folder("รูปลายเซ็นต์")
              .file(
                this.state.asset.asset_id === "-1"
                  ? "No Asset" + s + this.state.set_pic[i].pic_source_type
                  : this.state.asset.asset_id +
                  s +
                  this.state.set_pic[i].pic_source_type,
                setFile[i]
              );
            s += 1;
            break;
          case "F":
            zip
              .folder("Fix Problem")
              .file(
                this.state.asset.asset_id === "-1"
                  ? "No Asset" + f + this.state.set_pic[i].pic_source_type
                  : this.state.asset.asset_id +
                  f +
                  this.state.set_pic[i].pic_source_type,
                setFile[i]
              );
            f += 1;
            break;
          case "P":
            zip
              .folder("Job Progress Detail")
              .file(
                this.state.asset.asset_id === "-1"
                  ? "No Asset" + p + this.state.set_pic[i].pic_source_type
                  : this.state.asset.asset_id +
                  p +
                  this.state.set_pic[i].pic_source_type,
                setFile[i]
              );
            p += 1;
            break;
          case "E":
            zip
              .folder("Exclusion")
              .file(
                this.state.asset.asset_id === "-1"
                  ? "No Asset" + e + this.state.set_pic[i].pic_source_type
                  : this.state.asset.asset_id +
                  e +
                  this.state.set_pic[i].pic_source_type,
                setFile[i]
              );
            e += 1;
            break;
          case "Z":
            zip
              .folder("Finish Approve")
              .file(
                this.state.asset.asset_id === "-1"
                  ? "No Asset" + z + this.state.set_pic[i].pic_source_type
                  : this.state.asset.asset_id +
                  z +
                  this.state.set_pic[i].pic_source_type,
                setFile[i]
              );
            z += 1;
            break;
          case "X":
            zip
              .folder("Finish Reject")
              .file(
                this.state.asset.asset_id === "-1"
                  ? "No Asset" + x + this.state.set_pic[i].pic_source_type
                  : this.state.asset.asset_id +
                  x +
                  this.state.set_pic[i].pic_source_type,
                setFile[i]
              );
            x += 1;
            break;
          case "T":
            zip
              .folder("Stop Time")
              .file(
                this.state.asset.asset_id === "-1"
                  ? "No Asset" + t + this.state.set_pic[i].pic_source_type
                  : this.state.asset.asset_id +
                  t +
                  this.state.set_pic[i].pic_source_type,
                setFile[i]
              );
            t += 1;
            break;
        }
      }
      zip.generateAsync({ type: "blob" }).then((content) => {
        saveAs(
          content,
          this.state.asset.asset_id === "-1"
            ? "No Asset.zip"
            : this.state.asset.asset_id + ".zip"
        );
      });
    }, 1000);
  };

  converTypeImage = async () => {
    const settoDataURL = await this.toDataURL(
      "https://planb.maxitask.com/OperationStorage/Other/Hello/177936_202208021410254446.heic"
    );
    var fileData = this.dataURLtoFile(settoDataURL, "imageName.jpg");
    var newImage = await heic2any({
      blob: fileData,
      toType: "image/jpg",
      quality: 1,
    });
    const url = URL.createObjectURL(newImage);
    return url;
  };
  toDataURL = (url) =>
    fetch(url)
      .then((response) => response.blob())
      .then(
        (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
      );
  dataURLtoFile = (dataurl, filename) => {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  render() {
    const {
      step,
      data,
      visible,
      active_step,
      loading,
      clonedynamic_state,
      fileList,
    } = this.state;
    const uploadButton = (
      <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    );
    return (
      <LayoutOperation title="Full Detail Job">
        <Spin spinning={!this.state.factupdate} size="large" style={{ marginTop: "20%" }}>
          {this.renderCheckList()}
          {this.renderStoptimeApproval()}
          {this.renderStoptimeConfirmation()}
          {/* {this.renderImage()} */}
          {this.renderStoptimeResult()}

          {this.state.visible_modal_approve ? (
            <ModalGiveStarScore
              handleVisible={this.checkVisibleModalGiveScore.bind(this)}
              dataapprove={this.state.dataapprove}
            />
          ) : // null
            null}
          {this.state.visible_modal_reject_status ? (
            <ModalSuccess
              status="Reject"
              path_location="/MaxiOperation/ma_list"
            />
          ) : null}
          {this.state.visible_modal_reject ? (
            <Modal
              title={null}
              centered
              visible={true}
              footer={null}
              closable={false}
            >
              <div className="text-center">
                <h3 className="font-mont-sb font18 c-blue mt-3">
                  Reject Job{" "}
                  {
                    this.state.getFulldetail.data.data.result_maintenance[0]
                      .job_no
                  }{" "}
                </h3>
                <div className="row mt-3 mb-2">
                  <div className="col-3">
                    {" "}
                    <span>Reason : </span>
                  </div>
                  <div className="col-7">
                    <Select
                      // showSearch
                      style={{ border: "0px", textAlign: "left" }}
                      placeholder="Select a Reason"
                      className="inputfile"
                      // onChange={(value) => this.state.form["Reason"] = value }
                      onChange={(value) => (this.state.form["Reason"] = value)}
                    >
                      {this.state.maseter_reject.map((item, index) => (
                        <Select.Option
                          value={item.service_ma_reason_id}
                          key={index}
                        >
                          {item.service_ma_reason_desc}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-3">
                    {" "}
                    <span>Remark : </span>
                  </div>
                  <div className="col-7">
                    <textarea
                      style={{ width: "100%", height: "60px" }}
                      name="inform_remark"
                      onChange={(e) =>
                        (this.state.form["remark"] = e.target.value)
                      }
                    ></textarea>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-3">Upload :</div>
                  <div className="col-7">
                    <Upload
                      action={process.env.REACT_APP_URL_API + "mockupupload/"}
                      multiple={true}
                      listType="picture-card"
                      fileList={fileList}
                      onPreview={this.handlePreview}
                      onChange={this.handleChange}
                      onError={(e) => console.log(e)}
                      height={"20%"}
                    >
                      {fileList.length >= 8 ? null : uploadButton}
                    </Upload>
                  </div>
                </div>

                <button
                  onClick={() => this.setState({ visible_modal_reject: false })}
                  className="btn btn-secondary"
                >
                  Cancel
                </button>
                <button
                  // style={{
                  //   backgroundColor: "red",
                  //   borderColor: "red",
                  //   color: "#ffffff"
                  // }}
                  onClick={() => this.handleSubmitReject(true)}
                  className="btn btn-danger"
                >
                  Reject
                </button>
              </div>
            </Modal>
          ) : null}
          {this.renderModalApprove(visible.approve)}
          {this.renderModalReject(false)}
          {this.renderModalApproveSuccess(visible.approve_success)}
          {this.state.factupdate ? (
            <>
              {/* {this.converTypeImage()} */}
              <div className="wrapper-header" style={{ height: "284px" }}>
                <div className="container-fluid">
                  <div className="d-flex justify-content-between mb-2">
                    <a
                      className="font-thai-r font20 c-white"
                      onClick={() => parseInt(localStorage.getItem("jobID_Back")) === parseInt(Cookies.get("job_id")) ? this.props.history.goBack() : this.onBackJob()}

                    >
                      <i className="fas fa-chevron-left"></i>
                      <span style={{ marginLeft: "5px", marginBottom: "20px" }}>
                        Back
                      </span>
                    </a>

                    {parseInt(localStorage.getItem("jobID_Last")) !== parseInt(Cookies.get("job_id")) ?
                      <a
                        className="font-thai-r font20 c-white"
                        onClick={() => this.onNextJob()}
                      >
                        <span style={{ marginRight: "5px", marginBottom: "20px" }}>
                          Next
                        </span>
                        <i className="fas fa-chevron-right"></i>
                      </a>
                      : null}
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="d-flex">
                        <div className="mr-3 pt-2">
                          <img src={Api.absoluteUrl("/icon/name_job.svg")} />
                        </div>
                        <div>
                          <h2 className="font-thai-b font33 c-white mb-0">
                            {data.name}
                          </h2>
                          <span className="font-thai-i font20 c-white">
                            {this.state.data_mainttenance.job_area_name || "-"} /{" "}
                            {this.state.asset.team_name || "-"} /{" "}
                            {this.state.asset.team_sub_name || "-"}
                          </span>
                          <div className="mt-2">
                            {this.state.data_mainttenance.priority_level == 3 ||
                              this.state.data_mainttenance.priority_level == "3" ? (
                              <span className="badge badge-pill badge-primary font-thai-b font14 mr-2">
                                {this.state.factupdate ? (
                                  <span>
                                    {
                                      this.state.data_translate[
                                      Cookies.get("locale")
                                      ]["status_high"]
                                    }
                                  </span>
                                ) : null}
                              </span>
                            ) : null}
                            {this.state.data_mainttenance.priority_level == 2 ||
                              this.state.data_mainttenance.priority_level == "2" ? (
                              <span className="warning badge-pill badge-warning font-thai-b font16 mr-2">
                                {this.state.factupdate ? (
                                  <span className="warning badge-pill badge-warning font-thai-b font16 mr-2">
                                    {
                                      this.state.data_translate[
                                      Cookies.get("locale")
                                      ]["status_normal"]
                                    }
                                  </span>
                                ) : null}
                              </span>
                            ) : null}
                            {this.state.data_mainttenance.priority_level == 1 ||
                              this.state.data_mainttenance.priority_level == "1" ? (
                              <span className="success badge-pill badge-success font-thai-b font16 mr-2">
                                {this.state.factupdate ? (
                                  <span className="success badge-pill badge-success font-thai-b font16 mr-2">
                                    {
                                      this.state.data_translate[
                                      Cookies.get("locale")
                                      ]["status_low"]
                                    }
                                  </span>
                                ) : null}
                              </span>
                            ) : null}
                            <span className="badge badge-pill badge-secondary font-thai-sb font16 mr-2">
                              {this.state.data_mainttenance.job_type_name || "-"}
                            </span>
                            {/* <span className="badge badge-pill badge-light on-process font-thai-b font16">
                        <span className="dot-on-process mr-2">
                        </span>
                        On Process
                      </span> */}
                            {this.state.data_mainttenance.job_status == 7 ? (
                              <span className="badge badge-pill badge-light Wait-Reassign  font-thai-b font16">
                                <span className="dot-Wait-Reassign mr-2"></span>
                                {
                                  // this.state.jobstatus_name[
                                  //   this.state.data_mainttenance.job_status
                                  // ]

                                  this.state.data_mainttenance.job_status_name
                                }
                              </span>
                            ) : null}

                            {this.state.data_mainttenance.job_status == 9 ? (
                              <span className="badge badge-pill badge-light  Cancel font-thai-b font16">
                                <span className="dot-Cancel mr-2"></span>
                                {
                                  // this.state.jobstatus_name[
                                  //   this.state.data_mainttenance.job_status
                                  // ]
                                  this.state.data_mainttenance.job_status_name
                                }
                              </span>
                            ) : null}
                            {this.state.data_mainttenance.job_status == 8 ? (
                              <span className="badge badge-pill badge-light stop-time  font-thai-b font16">
                                <span className="dot-stop-time mr-2"></span>
                                {
                                  // this.state.jobstatus_name[
                                  //   this.state.data_mainttenance.job_status
                                  // ]
                                  this.state.data_mainttenance.job_status_name
                                }
                              </span>
                            ) : null}
                            {this.state.data_mainttenance.job_status == 3 ? (
                              <span className="badge badge-pill badge-light on-process font-thai-b font16">
                                <span className="dot-on-process mr-2"></span>
                                {
                                  // this.state.jobstatus_name[
                                  //   this.state.data_mainttenance.job_status
                                  // ]
                                  this.state.data_mainttenance.job_status_name
                                }
                              </span>
                            ) : null}
                            {this.state.data_mainttenance.job_status != 3 &&
                              this.state.data_mainttenance.job_status != 7 &&
                              this.state.data_mainttenance.job_status != 8 &&
                              this.state.data_mainttenance.job_status != 9 ? (
                              <span className="badge badge-pill badge-light font-thai-b font16">
                                {
                                  // this.state.jobstatus_name[
                                  //   this.state.data_mainttenance.job_status
                                  // ]
                                  this.state.data_mainttenance.job_status_name
                                }
                              </span>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 text-right">
                      {/* <button className="btn btn-warning mr-2" onClick={()=>this.onApprove()}>
                                    <img src="/icon/quotation.svg" className="mr-2"/>Quotation
                                </button> */}

                      <button
                        className={
                          this.state.check_approve
                            ? "btn btn-danger mr-2 divshow"
                            : "btn btn-danger mr-2 divhide"
                        }
                        // className="btn btn-danger mr-2 divshow"
                        onClick={() => this.onReject()}
                      >
                        <img
                          src={Api.absoluteUrl("/icon/reject.svg")}
                          className="mr-2"
                        />
                        Reject
                      </button>
                      <button
                        className={
                          this.state.check_approve
                            ? "btn btn-success mr-2 divshow"
                            : " btn btn-success mr-2 divhide"
                        }
                        // className="btn btn-success mr-2 divshow"
                        onClick={() => this.onApprove()}
                      >
                        <img
                          src={Api.absoluteUrl("/icon/approve.svg")}
                          className="mr-2"
                        />
                        Approve
                      </button>

                      {/* Stop time approval */}
                      {this.state.check_stop_time === true ? (
                        <div>
                          <h6 style={{ color: "#FF0000" }}>
                            {/* {this.state.display_stop_time} */}
                          </h6>
                          {/* <h6
                          style={{
                            color: "#FFFFFF",
                            fontSize: "13px",
                            marginTop: "-9px",
                            fontWeight: "100",
                            marginRight: "10px",
                          }}
                        ></h6> */}
                          <button
                            className={"btn mr-2 divshow"}
                            // className="btn btn-success mr-2 divshow"
                            onClick={() => this.approvalModal(1)}
                            style={{
                              border: "1px solid #f00",
                              color: "#f00",
                            }}
                          >
                            <img
                              src={Api.absoluteUrl("/icon/stop_time_2.svg")}
                              className="mr-2"
                            />
                            Stop Time
                          </button>
                        </div>
                      ) : null}
                      <button
                        className="btn btn-gray"
                        style={{
                          float: "right",
                          color: "#FFFFFF",
                          backgroundColor: "#888888",
                        }}
                        onClick={() => this.exportZip()}
                      >
                        {/* <img
                        src={Api.absoluteUrl("/icon/plus.svg")}
                        width="14"
                        className="mr-2"
                      /> */}
                        Export
                      </button>
                    </div>
                  </div>
                  <div className="card-step-job">
                    <ul className="text-center">
                      {step.map((item, index) => (
                        <li
                          key={index}
                          className={index < active_step ? "active" : ""}
                        >
                          <img
                            src={
                              index < active_step
                                ? Api.absoluteUrl(
                                  "/icon/step_" + (index + 1) + ".svg"
                                )
                                : Api.absoluteUrl(
                                  "/icon/step_" + (index + 1) + "_gray.svg"
                                )
                            }
                          />
                          <div className="step-status">
                            <img
                              src={
                                index < active_step
                                  ? Api.absoluteUrl("/icon/step_success.svg")
                                  : Api.absoluteUrl("/icon/step_wait.svg")
                              }
                            />
                          </div>
                          <p className="font-mont-m font12">{item.text}</p>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              <div className="wrapper-body">
                <div className="container-fluid">
                  <div className="row" style={{ marginTop: "80px" }}>
                    <div className="col-4">
                      <Collapse
                        defaultActiveKey={
                          this.state.asset.asseT_CODE === null
                            ? ["1", "3", "4"]
                            : ["1", "2", "3", "4"]
                        }
                        expandIconPosition="right"
                      >
                        <Panel
                          header={
                            <div>
                              <img
                                src={Api.absoluteUrl("/icon/asset_detail.svg")}
                                className="mr-3"
                              />
                              <span className="c-blue text-uppercase">
                                {this.state.factupdate ? (
                                  <span className="c-blue text-uppercase">
                                    {" "}
                                    {
                                      this.state.data_translate[
                                      Cookies.get("locale")
                                      ]["asset_detail"]
                                    }
                                  </span>
                                ) : null}
                              </span>
                            </div>
                          }
                          key="1"
                        >
                          <div className="mb-3">
                            <img
                              src={Api.absoluteUrl("/img/img_job.png")}
                              className="img-fluid"
                            />
                          </div>
                          <div className="full-detail-job-des">
                            <div className="row">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  {" "}
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {" "}
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["asset_code"]
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.asset.asseT_CODE}
                                </span>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  {" "}
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {" "}
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["asset_name"]
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.asset.asseT_NAME}
                                </span>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {" "}
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["group_type"]
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.asset.group_type_name || "-"}
                                </span>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {" "}
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["job_detail"]
                                      }
                                    </span>
                                  ) : null}
                                  {/* {this.state.factupdate ? (
                          <span>
                            {" "}
                            {
                              this.state.data_translate[Cookies.get("locale")][
                                "job_detail"
                              ]
                            }
                          </span>
                        ) : null} */}
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.asset.asset_type_name}
                                </span>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {" "}
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["asset_sub_type"]
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.asset.asset_sub_type_name}
                                </span>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {" "}
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["model_number"]
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.asset.model_no || "-"}
                                </span>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {" "}
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["serial_number"]
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.asset.serial_no}
                                </span>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {" "}
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["date_install"]
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.asset.datE_INSTALL || "-"}
                                </span>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {" "}
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["warranty"]
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-red">
                                  {/* {this.state.asset.warranty_expire} */}
                                  {this.state.asset.warranty_expire ===
                                    "Invalid date"
                                    ? "-"
                                    : moment(
                                      this.state.asset.warranty_expire
                                    ).format("DD/MM/YYYY") || "-"}
                                </span>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {" "}
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["ma_period"]
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.asset["ma_period"]}
                                </span>
                              </div>
                            </div>
                            <div className="row divhide">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {" "}
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["type_screen"]
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.asset.type_sceen}
                                </span>
                              </div>
                            </div>
                            <div className="row divhide">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {" "}
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["format"]
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.asset.format}
                                </span>
                              </div>
                            </div>
                            <div className="row divhide">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {" "}
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["resolution"]
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.asset.resolution}
                                </span>
                              </div>
                            </div>
                            <div className="row divhide">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {" "}
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["eyeball_month"]
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.asset.eyeball_month}
                                  {"-"}
                                </span>
                              </div>
                            </div>
                            <div className="row divhide">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {" "}
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["width"]
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.asset.width}
                                </span>
                              </div>
                            </div>
                            <div className="row divhide">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {" "}
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["length"]
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.asset.length}
                                </span>
                              </div>
                            </div>
                            <div className="row divhide">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {" "}
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["height"]
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.asset.height}
                                </span>
                              </div>
                            </div>
                            <div className="row divhide">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  {" "}
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {" "}
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["sqm"]
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.asset.sqm}
                                </span>
                              </div>
                            </div>
                          </div>
                        </Panel>
                        <Panel
                          header={
                            <div>
                              <img
                                src={Api.absoluteUrl("/icon/icon_location.svg")}
                                className="mr-3"
                              />
                              <span className="c-blue text-uppercase">
                                {this.state.factupdate ? (
                                  <span className="font-thai-b font18">
                                    {"Location"}
                                  </span>
                                ) : null}
                              </span>
                            </div>
                          }
                          key="2"
                        >
                          <div className="full-detail-job-des">
                            <div className="row">
                              <div className="col-5">
                                {" "}
                                <span className="font-thai-b font18">
                                  {"Location"}
                                </span>{" "}
                              </div>
                              <div className="col-7">
                                {" "}
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.data_mainttenance.location_name}
                                </span>
                              </div>
                              <div className="col-5">
                                {" "}
                                <span className="font-thai-b font18">
                                  {"Latitude"}
                                </span>{" "}
                              </div>
                              <div className="col-7">
                                {" "}
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.data_mainttenance.latitude || "-"}
                                </span>
                              </div>
                              <div className="col-5">
                                {" "}
                                <span className="font-thai-b font18">
                                  {"Longitude"}
                                </span>{" "}
                              </div>
                              <div className="col-7">
                                {" "}
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.data_mainttenance.longitude || "-"}
                                </span>
                              </div>
                              <div className="col-12 mt-2">
                                {loading === false ? (
                                  <div
                                    className={
                                      this.state.data_mainttenance.latitude ===
                                        null
                                        ? "divhide"
                                        : "position-relative"
                                    }
                                    style={{ height: "202px" }}
                                  >
                                    <Map
                                      center={{
                                        lat: this.state.data_mainttenance
                                          .latitude,
                                        lng: this.state.data_mainttenance
                                          .longitude,
                                      }}
                                      zoom={13}
                                    />
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </Panel>
                        <Panel
                          header={
                            <div>
                              <img
                                src={Api.absoluteUrl("/icon/material.svg")}
                                className="mr-3"
                              />
                              <span className="c-blue text-uppercase">
                                {this.state.factupdate ? (
                                  <span className="font-thai-b font18">
                                    {" "}
                                    {
                                      this.state.data_translate[
                                      Cookies.get("locale")
                                      ]["material"]
                                    }
                                  </span>
                                ) : null}
                              </span>
                            </div>
                          }
                          key="3"
                        >
                          <div className="full-detail-job-des">
                            <div className="row">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {" "}
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["module"]
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.data_material.modal_material}
                                </span>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {" "}
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["power"]
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.data_material.power_supply}
                                </span>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {" "}
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["receiving"]
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.data_material.receiving_card}
                                </span>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {" "}
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["sending_box"]
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.data_material.sending}
                                </span>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  {" "}
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {" "}
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["hub"]
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.data_material.hub}
                                </span>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  จอ TV LCD
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.data_material.tv}
                                </span>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-5">
                                <span className="font-thai-b font18">
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["other"]
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <div className="col-7">
                                <span className="font-thai-sb font18 c-blue">
                                  {this.state.data_material.other}
                                </span>
                              </div>
                            </div>
                          </div>
                        </Panel>
                      </Collapse>
                    </div>
                    <div className="col-8">
                      <Collapse
                        defaultActiveKey={["1", "2"]}
                        expandIconPosition="right"
                      >
                        <Panel
                          header={
                            <div>
                              <img
                                src={Api.absoluteUrl("/icon/job_maintenance.svg")}
                                className="mr-3"
                              />
                              <span className="c-blue text-uppercase">
                                Job Maintenance
                              </span>
                            </div>
                          }
                          key="1"
                        >
                          <div className="row">
                            <div className="col-12">
                              <div className="row">
                                <div className="col-6">
                                  <div className="mb-3">
                                    <div>
                                      <img
                                        src={Api.absoluteUrl(
                                          "/icon/name_job_blue.svg"
                                        )}
                                        className="mr-2"
                                      />
                                      <span className="font-thai-b font22 c-blue">
                                        {data.name}
                                      </span>
                                    </div>
                                    <div
                                      className="full-detail-job-des"
                                      style={{ margin: "0 22px" }}
                                    >
                                      <div className="row">
                                        <div className="col-6">
                                          <span className="font-thai-b font18">
                                            {this.state.factupdate ? (
                                              <span className="font-thai-b font18">
                                                {" "}
                                                {
                                                  this.state.data_translate[
                                                  Cookies.get("locale")
                                                  ]["job_id"]
                                                }
                                              </span>
                                            ) : null}
                                          </span>
                                        </div>
                                        <div className="col-6 pl-0">
                                          <span className="font-thai-sb font18 c-blue">
                                            {this.state.data_mainttenance
                                              .job_no || "-"}
                                          </span>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-6">
                                          <span className="font-thai-b font18">
                                            {this.state.factupdate ? (
                                              <span className="font-thai-b font18">
                                                {
                                                  this.state.data_translate[
                                                  Cookies.get("locale")
                                                  ]["job_category"]
                                                }
                                              </span>
                                            ) : null}
                                          </span>
                                        </div>
                                        <div className="col-6 pl-0">
                                          <span className="badge badge-pill badge-secondary font-thai-sb font16 mr-2">
                                            {this.state.getFulldetail.data.data
                                              .result_maintenance[0]
                                              .job_category_name || "-"}
                                          </span>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-6">
                                          <span className="font-thai-b font18">
                                            {this.state.factupdate ? (
                                              <span className="font-thai-b font18">
                                                {
                                                  this.state.data_translate[
                                                  Cookies.get("locale")
                                                  ]["job_type"]
                                                }
                                              </span>
                                            ) : null}
                                          </span>
                                        </div>
                                        <div className="col-6 pl-0">
                                          <span className="badge badge-pill badge-secondary font-thai-sb font16 mr-2">
                                            {this.state.data_mainttenance
                                              .job_type_name || "-"}
                                          </span>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-6">
                                          <span className="font-thai-b font18">
                                            {this.state.factupdate ? (
                                              <span className="font-thai-b font18">
                                                {
                                                  this.state.data_translate[
                                                  Cookies.get("locale")
                                                  ]["area_code"]
                                                }
                                              </span>
                                            ) : null}
                                          </span>
                                        </div>
                                        <div className="col-6 pl-0">
                                          <span className="font-thai-sb font18 c-blue">
                                            {this.state.data_mainttenance
                                              .job_area_name || "-"}
                                          </span>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-6">
                                          <span className="font-thai-b font18">
                                            {this.state.factupdate ? (
                                              <span className="font-thai-b font18">
                                                {" "}
                                                {
                                                  this.state.data_translate[
                                                  Cookies.get("locale")
                                                  ]["sub_code_area"]
                                                }
                                              </span>
                                            ) : null}
                                          </span>
                                        </div>
                                        <div className="col-6 pl-0">
                                          <span className="font-thai-sb font18 c-blue">
                                            {this.state.data_mainttenance
                                              .job_sub_area_name || "-"}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-6">
                                  <div>
                                    <div>
                                      <img
                                        src={Api.absoluteUrl("/icon/people.svg")}
                                        className="mr-2"
                                      />
                                      <span className="font-thai-b font22 c-blue">
                                        {this.state.factupdate ? (
                                          <span className="font-thai-b font22 c-blue">
                                            {" "}
                                            {
                                              this.state.data_translate[
                                              Cookies.get("locale")
                                              ]["job_assignment"]
                                            }
                                          </span>
                                        ) : null}
                                      </span>
                                    </div>
                                    <div
                                      className="full-detail-job-des"
                                      style={{ margin: "0 22px" }}
                                    >
                                      <div className="row">
                                        <div className="col-6">
                                          <span className="font-thai-b font18">
                                            {this.state.factupdate ? (
                                              <span className="font-thai-b font18">
                                                {" "}
                                                {
                                                  this.state.data_translate[
                                                  Cookies.get("locale")
                                                  ]["assign_team_group"]
                                                }
                                              </span>
                                            ) : null}
                                          </span>
                                        </div>
                                        <div className="col-6 pl-0">
                                          <span className="font-thai-sb font18 c-blue">
                                            {
                                              this.state.data_assignment
                                                .team_group_name
                                            }
                                          </span>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-6">
                                          <span className="font-thai-b font18">
                                            {this.state.factupdate ? (
                                              <span className="font-thai-b font18">
                                                {" "}
                                                {
                                                  this.state.data_translate[
                                                  Cookies.get("locale")
                                                  ]["mtn_name"]
                                                }
                                              </span>
                                            ) : null}
                                          </span>
                                        </div>
                                        <div className="col-6 pl-0">
                                          <span className="font-thai-sb font18 c-blue">
                                            {this.state.data_assignment
                                              .assignjob_emp_name || "-"}
                                          </span>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-6">
                                          <span className="font-thai-b font18">
                                            {this.state.factupdate ? (
                                              <span className="font-thai-b font18">
                                                {"Assign By"}
                                              </span>
                                            ) : null}
                                          </span>
                                        </div>
                                        <div className="col-6 pl-0">
                                          <span className="font-thai-sb font18 c-blue">
                                            {this.state.data_assignment
                                              .actjob_emp_name || "-"}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="row">
                                <div className="col-4">
                                  <img
                                    src={Api.absoluteUrl(
                                      "/icon/inform_person.svg"
                                    )}
                                    className="mr-2"
                                  />
                                  <span className="font-thai-b font22 c-blue">
                                    {"Inform Person"}
                                  </span>
                                </div>
                                <div className="col-7 pt-1">
                                  <span className="font-thai-sb font18 c-blue"></span>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div>
                                <img
                                  src={Api.absoluteUrl("/icon/inform_detail.svg")}
                                  className="mr-2"
                                />
                                <span className="font-thai-b font22 c-blue">
                                  {this.state.factupdate ? (
                                    <span className="font-thai-b font18">
                                      {" "}
                                      {
                                        this.state.data_translate[
                                        Cookies.get("locale")
                                        ]["inform_detail"]
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <div
                                className="full-detail-job-des"
                                style={{ margin: "0 22px" }}
                              >
                                {this.state.label_informDetail.map(
                                  (value, index) => {
                                    return (
                                      <div className="row">
                                        <div className="col-6">
                                          <span className="font-thai-b font18">
                                            {this.state.factupdate ? (
                                              <span className="font-thai-b font18">
                                                {value.text}
                                              </span>
                                            ) : null}
                                          </span>
                                        </div>
                                        <div className="col-6 pl-0">
                                          <span
                                            className="font-thai-sb font18 c-blue"
                                            style={{ wordBreak: "break-word" }}
                                          >
                                            {value.value === "last_assign_date" ||
                                              value.value === "emp_inform_date" ? (
                                              moment(
                                                this.state.data_mainttenance[
                                                value.value
                                                ]
                                              ).format("DD/MM/YYYY")
                                            ) : (
                                              <>
                                                {value.value === "ma_period"
                                                  ? this.state.asset["ma_period"]
                                                  : this.state.data_mainttenance[
                                                    value.value
                                                  ] === "not found id" ||
                                                    this.state.data_mainttenance[
                                                    value.value
                                                    ] === null ||
                                                    this.state.data_mainttenance[
                                                    value.value
                                                    ] === undefined
                                                    ? "-"
                                                    : this.state.data_mainttenance[
                                                    value.value
                                                    ]}
                                              </>
                                            )}
                                          </span>
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            </div>
                            <div className="col-6">
                              <div
                                className="full-detail-job-des"
                                style={{ margin: "0 22px", marginTop: "34px" }}
                              >
                                {this.state.label_informDetail_right.map(
                                  (value, index) => {
                                    return (
                                      <div className="row">
                                        <div className="col-6">
                                          <span className="font-thai-b font18">
                                            {this.state.factupdate ? (
                                              <span className="font-thai-b font18">
                                                {value.text}
                                              </span>
                                            ) : null}
                                          </span>
                                        </div>
                                        <div className="col-6 pl-0">
                                          <span
                                            className="font-thai-sb font18 c-blue"
                                            style={{ wordBreak: "break-word" }}
                                          >
                                            {value.value === "priority_level" ? (
                                              <>
                                                {this.state.data_mainttenance[
                                                  value.value
                                                ] === "3" ? (
                                                  <span className="badge badge-pill badge-primary font-thai-b font14 mr-2">
                                                    High
                                                  </span>
                                                ) : null}
                                                {this.state.data_mainttenance[
                                                  value.value
                                                ] === "2" ? (
                                                  <span className="warning badge-pill badge-warning font-thai-b font16 mr-2">
                                                    Normal
                                                  </span>
                                                ) : null}
                                                {this.state.data_mainttenance[
                                                  value.value
                                                ] === "1" ? (
                                                  <span className="success badge-pill badge-success font-thai-b font16 mr-2">
                                                    Low
                                                  </span>
                                                ) : null}
                                              </>
                                            ) : this.state.data_mainttenance[
                                              value.value
                                            ] === "not found id" ||
                                              this.state.data_mainttenance[
                                              value.value
                                              ] === null ||
                                              this.state.data_mainttenance[
                                              value.value
                                              ] === undefined ? (
                                              "-"
                                            ) : (
                                              this.state.data_mainttenance[
                                              value.value
                                              ]
                                            )}
                                          </span>
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                                <div
                                  className="mt-2"
                                  style={{
                                    padding: "5px",
                                    border: "0.5px solid #c1b7b7",
                                  }}
                                >
                                  <div className="row mt-2">
                                    {this.state.set_pic.map((data, index) => {
                                      return (
                                        <>
                                          {(data.pic_upload_type.toLowerCase() ===
                                            ".jpg" ||
                                            data.pic_upload_type.toLowerCase() ===
                                            ".png" ||
                                            data.pic_upload_type.toLowerCase() ===
                                            ".jpeg" ||
                                            data.pic_upload_type.toLowerCase() ===
                                            ".svg") &&
                                            data.pic_type === "O" ? (
                                            <div class="col-auto">
                                              <Image
                                                className="ml-1 mb-1"
                                                style={{ cursor: "pointer" }}
                                                width={150}
                                                height={80}
                                                src={Api.checkPath(
                                                  data.pic_url_path,
                                                  data.pic_upload_name
                                                )}
                                              />
                                            </div>
                                          ) : (data.pic_upload_type.toLowerCase() ===
                                            ".mp4" ||
                                            data.pic_upload_type.toLowerCase() ===
                                            ".avi" ||
                                            data.pic_upload_type.toLowerCase() ===
                                            ".mov" ||
                                            data.pic_upload_type.toLowerCase() ===
                                            ".wmv") &&
                                            data.pic_type === "O" ? (
                                            <div class="col-auto">
                                              <video
                                                width="150"
                                                controls
                                                className="ml-1 mb-1 mr-1"
                                                style={{ height: "80px" }}
                                              >
                                                <source
                                                  src={Api.checkPath(
                                                    data.pic_url_path,
                                                    data.pic_upload_name
                                                  )}
                                                  type="video/mp4"
                                                ></source>
                                              </video>
                                            </div>
                                          ) : (data.pic_upload_type.toLowerCase() ===
                                            ".pdf" ||
                                            data.pic_upload_type.toLowerCase() ===
                                            ".xlsx" ||
                                            data.pic_upload_type.toLowerCase() ===
                                            ".xls" ||
                                            data.pic_upload_type.toLowerCase() ===
                                            ".doc" ||
                                            data.pic_upload_type.toLowerCase() ===
                                            ".txt") &&
                                            data.pic_type === "O" ? (
                                            <div class="col-auto">
                                              <a
                                                href={Api.checkPath(
                                                  data.pic_url_path,
                                                  data.pic_upload_name
                                                )}
                                                download
                                              >
                                                <CopyOutlined
                                                  style={{ marginRight: "5px" }}
                                                />

                                                {data.pic_upload_name}
                                              </a>
                                            </div>
                                          ) : null}
                                        </>
                                      );
                                    })}
                                  </div>
                                </div>
                              </div>
                            </div>
                            {clonedynamic_state &&
                              clonedynamic_state !== null &&
                              clonedynamic_state !== undefined &&
                              Object.keys(clonedynamic_state).length > 0 ? (
                              <div className="col-6">
                                <div>
                                  <img
                                    src={Api.absoluteUrl("/icon/asset_layer.svg")}
                                    className="mr-2"
                                  />
                                  <span className="font-thai-b font22 c-blue">
                                    <span className="font-thai-b font22">
                                      Dynamic Data
                                    </span>
                                  </span>
                                </div>
                                <div
                                  className="full-detail-job-des"
                                  style={{ margin: "0 22px" }}
                                >
                                  <Renderdynamic
                                    data={clonedynamic_state}
                                  ></Renderdynamic>
                                </div>
                              </div>
                            ) : null}
                          </div>
                          <div
                            className="col-2"
                            style={{ textAlign: "center" }}
                          ></div>
                        </Panel>
                        <Panel
                          // className="divhide"
                          header={
                            <div>
                              <img
                                src={Api.absoluteUrl(
                                  "/icon/customer_service_report.svg"
                                )}
                                className="mr-3"
                              />
                              <span className="c-blue text-uppercase ">
                                {this.state.factupdate ? (
                                  <span className="c-blue text-uppercase ">
                                    {"MAINTENENCE REPORT"}
                                  </span>
                                ) : null}
                              </span>
                            </div>
                          }
                          key="2"
                        >
                          {this.rendermainternence_report()}
                        </Panel>
                      </Collapse>
                    </div>
                    <div className="col-12 divhide">
                      <div className="card">
                        <div
                          style={{ height: "40px", backgroundColor: "#0500A3" }}
                        >
                          <h5
                            style={{
                              color: "#fff",
                              padding: "10px",
                              marginLeft: "10px",
                              fontSize: "18px",
                            }}
                          >
                            {"Record Problem"}
                          </h5>
                        </div>
                        <div className="card-body">
                          <Table
                            columns={this.state.record_problem}
                            // dataSource={job_history}
                            pagination={false}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {this.state.visibleDrawer ? this.renderDrawer() : null}
                </div>
              </div>
            </>
          ) : null}
        </Spin>
      </LayoutOperation>
    );
  }

  renderStoptimeApproval() {
    return (
      <Modal
        centered
        visible={this.state.visible_stoptime}
        footer={null}
        closable={true}
        width={"35%"}
        zIndex={90}
        destroyOnClose={true}
        onCancel={() =>
          this.setState({
            visible_stoptime: false,
          })
        }
        bodyStyle={{
          marginTop: "5%",
          paddingTop: "5px",
          paddingLeft: "15px",
          paddingRight: "15px",
          paddingBottom: "0",
          minWidth: "420px",
        }}
      >
        <div className="text-left">
          <h3
            className="font-mont-sb font18 c-blue mt-3"
            style={{ align: "left" }}
          >
            Req. Stop Time
          </h3>
          <div
            className="row"
            style={{
              background: "#F8F9FA",
              paddingLeft: "50px",
              paddingRight: "50px",
              minHeight: "150px",
            }}
          >
            {Cookies.get("locale") == "en" ? (
              <div className="col-4" style={{ paddingRight: "5px" }}>
                Reason:
              </div>
            ) : (
              <div className="col-4" style={{ paddingRight: "5px" }}>
                เหตุผล:
              </div>
            )}
            {
              <div className="col-8" style={{ paddingLeft: "0px" }}>
                {" "}
                {!this.state.getFulldetail
                  ? ""
                  : !this.state.getFulldetail.data.data.result_stop_time[0]
                    ? ""
                    : this.state.getFulldetail.data.data.result_stop_time[0]
                      .job_stop_reason}{" "}
              </div>
            }
            {Cookies.get("locale") == "en" ? (
              <div className="col-4" style={{ paddingRight: "5px" }}>
                Remark:
              </div>
            ) : (
              <div className="col-4" style={{ paddingRight: "5px" }}>
                หมายเหตุ:
              </div>
            )}
            {
              <div className="col-8" style={{ paddingLeft: "0px" }}>
                {" "}
                {!this.state.getFulldetail
                  ? ""
                  : !this.state.getFulldetail.data.data.result_stop_time[0]
                    ? ""
                    : this.state.getFulldetail.data.data.result_stop_time[0]
                      .job_stop_remark}{" "}
              </div>
            }
            {Cookies.get("locale") == "en" ? (
              <div className="col-4" style={{ paddingRight: "5px" }}>
                Req. By:
              </div>
            ) : (
              <div className="col-4" style={{ paddingRight: "5px" }}>
                ร้องขอโดย:
              </div>
            )}
            {
              <div className="col-8" style={{ paddingLeft: "0px" }}>
                {" "}
                {!this.state.getFulldetail
                  ? ""
                  : !this.state.getFulldetail.data.data.result_stop_time[0]
                    ? ""
                    : this.state.getFulldetail.data.data.result_stop_time[0]
                      .request_user_name}{" "}
              </div>
            }
          </div>
          <div className="row text-center">
            <div className="col-6">
              <button
                onClick={() =>
                  this.setState({
                    approval_visible: true,
                    approval_flag: 0,
                  })
                }
                className="btn btn-secondary"
                style={{ width: "150px", color: "#f00" }}
              >
                Reject
              </button>
            </div>
            <div className="col-6">
              <button
                onClick={() =>
                  this.setState({
                    approval_visible: true,
                    approval_flag: 1,
                  })
                }
                className="btn btn-success"
                style={{ width: "150px" }}
              >
                Approve
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
  approvalModal(appvflag) {
    this.setState({
      visible_stoptime: true,
    });
  }
  stoptimeresultclose = () => {
    this.setState({
      stoptimeresult: false,
    });
  };
  renderStoptimeResult() {
    return (
      <Modal
        title={null}
        centered
        visible={this.state.stoptimeresult}
        footer={null}
        closable={this.state.stoptimeerrorDetail ? true : false}
        maskClosable={this.state.stoptimeerrorDetail ? true : false}
        onCancel={this.stoptimeresultclose}
      >
        <div className="text-center">
          {!this.state.stoptimeerrorDetail ? (
            <img
              src={ServiceApi.absoluteUrl("/img/modal_approve.svg")}
              className="img-fluid"
            />
          ) : (
            <img
              src={ServiceApi.absoluteUrl("/img/login_error.png")}
              className="img-fluid"
            />
          )}

          <h3
            className={
              "font-mont-sb font18 mt-3" +
              (!this.state.stoptimeerrorDetail ? " c-blue" : " c-red")
            }
          >
            {!this.state.stoptimeerrorDetail
              ? "Successfully " +
              (!this.state.approval_flag == 1
                ? "approve stoptime"
                : "reject stoptime")
              : "Failed"}
          </h3>
          {!this.state.stoptimeerrorDetail ? (
            <Fragment>
              redirecting{" "}
              <div
                className="spinner-border position-relative"
                style={{
                  width: "2rem",
                  height: "2rem",
                  left: "0.5rem",
                  top: "0.5rem",
                  zIndex: 1001,
                }}
                role="status"
              >
                <span className="sr-only">Loading...</span>
              </div>
            </Fragment>
          ) : (
            <Fragment>{this.state.stoptimeerrorDetail}</Fragment>
          )}
        </div>
      </Modal>
    );
  }
  stoptimeApproval(appvflag) {
    let fdetail = !this.state.getFulldetail
      ? []
      : !this.state.getFulldetail.data.data.result_maintenance[0]
        ? []
        : this.state.getFulldetail.data.data.result_maintenance[0];
    let thisjson = {
      company_id: fdetail.company_id,
      operator_id: fdetail.operator_id,
      project_id: fdetail.project_id,
      job_id: fdetail.job_id,
      job_progress_id: fdetail.job_progress_id,
      create_by: Cookies.get("username"),
      location_lat: fdetail.latitude,
      location_long: fdetail.longitude,
      progress_Status_flag: fdetail.progress_status,
      jobtypeid: fdetail.jobtypeid,
      jobActionConfig: null,
      maTypeId: Cookies.get("maType"),
      checkFlag: appvflag,
    };
    let wfdetail = {
      WF_ID: fdetail.wf_id,
      CompanyID: fdetail.company_id,
      ProjectID: fdetail.project_id,
      JobTypeID: fdetail.jobtypeid,
      MainProcessID: fdetail.mainProcessID,
      SubProcessID: fdetail.subProcessID,
      UserName: Cookies.get("username"),
      operator_id: Cookies.get("operator_id"),
    };
    let wfresult;
    Api.post("getButtonDetailWeb", wfdetail).then((val) => {
      wfresult = val.data.return_nextWorkFlow[appvflag];
      let appvjson = {};
      Object.keys(thisjson).forEach((key) => (appvjson[key] = thisjson[key]));
      Object.keys(wfresult).forEach((key) => (appvjson[key] = wfresult[key]));
      if (appvflag == 0) {
        appvjson["reject_reason_id"] = this.state.timerejectreason;
        appvjson["approve_remark"] = this.state.timerejectremark;
      }
      Api.post("update_oper_job_approve_stoptime", appvjson).then((val) => {
        if (val.data.result.code == "P") {
          // do success
          this.setState({
            stoptimeresult: true,
            approval_visible: false,
            visible_stoptime: false,
          });
          setTimeout(function () {
            window.location.assign("/MaxiOperation/ma_list");
          }, 1000);
        } else {
          // alert failure
          this.setState({
            stoptimeresult: true,
            approval_visible: false,
            visible_stoptime: false,
          });
        }
      });
    });
  }
  renderStoptimeConfirmation() {
    return (
      <Modal
        title={null}
        centered
        visible={this.state.approval_visible}
        footer={null}
        closable={true}
        zIndex={91}
        onCancel={() =>
          this.setState({
            approval_visible: false,
          })
        }
      >
        {this.state.approval_flag == 1 ? (
          <div className="text-center">
            <img
              src={Api.absoluteUrl("/img/modal_approve.svg")}
              className="img-fluid"
            />
            <h3 className="font-mont-sb font18 c-blue mt-3">
              Confirm Approve this stop time request ?
            </h3>
            <button
              onClick={() =>
                this.setState({
                  approval_visible: false,
                })
              }
              className="btn btn-secondary"
            >
              Cancel
            </button>
            <button
              onClick={() => this.stoptimeApproval(1)}
              className="btn btn-success"
            >
              Confirm
            </button>
          </div>
        ) : (
          <Form onFinish={(values) => null} layout="vertical">
            <Form.Item
              name="reason"
              label={<div className="font-mont-m font12">Reason</div>}
              rules={[
                {
                  required: true,
                  message: "โปรดเขียนรายละเอียด",
                },
              ]}
            >
              <Select
                className="font-mont-r font12"
                size="large"
                placeholder={"Please select reason"}
                style={{ marginBottom: "5px" }}
                onChange={(e) => {
                  this.setState({
                    timerejectreason: e,
                  });
                }}
              >
                {this.state.stoptimereason.map((item) => {
                  return (
                    <Option
                      key={item.service_ma_reason_id}
                      value={item.service_ma_reason_id}
                    >
                      {item.service_ma_reason_desc}
                    </Option>
                  );
                })}
              </Select>
              <Input.TextArea
                rows={4}
                placeholder="เขียนรายละเอียด"
                onChange={(e) => {
                  this.setState({
                    timerejectremark: e.target.value,
                  });
                }}
              />
            </Form.Item>
            <Form.Item className="mb-0 text-center">
              <button
                type="reset"
                onClick={() =>
                  this.setState({
                    approval_visible: false,
                  })
                }
                className="btn btn-secondary"
              >
                Cancel
              </button>
              <button
                className="btn btn-danger"
                onClick={() => this.stoptimeApproval(0)}
              >
                Reject
              </button>
            </Form.Item>
          </Form>
        )}
      </Modal>
    );
  }

  onNextJob() {
    var setJson = JSON.parse(localStorage.getItem("dataNext"));
    var nextJson = [];
    for (let i = 0; i < setJson.length; i++) {
      if (parseInt(Cookies.get("job_id")) === setJson[i]["job_id"]) {
        nextJson = setJson[i + 1];
      }
    }
    Cookies.set("maType", nextJson.ma_type);
    Cookies.set("job_id", nextJson.job_id);
    Cookies.set("job_progress_id", nextJson.job_progress_id);
    Cookies.set("job_type_id", nextJson.job_type_id);
    this.onLoadData();
  }

  onBackJob() {
    var setJson = JSON.parse(localStorage.getItem("dataNext"));
    var nextJson = [];
    for (let i = 0; i < setJson.length; i++) {
      if (parseInt(Cookies.get("job_id")) === setJson[i]["job_id"]) {
        nextJson = setJson[i - 1];
      }
    }
    Cookies.set("maType", nextJson.ma_type);
    Cookies.set("job_id", nextJson.job_id);
    Cookies.set("job_progress_id", nextJson.job_progress_id);
    Cookies.set("job_type_id", nextJson.job_type_id);
    this.onLoadData();
  }

}



const mapStateToProps = (state) => ({
  lang: state.lang,
  dynamicReducer: state.dynamicReducer,
});
const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
    setDynamic: (data) => dispatch(setDynamic(data)),
  };
};

export default connect(mapStateToProps, mapDispacthToProps)(FullDetailJob);
